<div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mx-4 my-2" [ngClass]="customClass">
  <div class="flex items-center">
    @if (showIcon) {
      <svg
        class="w-5 h-5 text-yellow-400 mr-2"
        fill="currentColor"
        viewBox="0 0 20 20"
        >
        <path
          fill-rule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        ></path>
      </svg>
    }
    <span class="text-yellow-800">{{ message }}</span>
  </div>
</div>